import bdnewchannel3 from '@/views/channel/bdnewchannel3'
export default [{
  path: '/bdnewchannel3',
  name: 'kid-test03',
  component: bdnewchannel3,
  description: '渠道落地页'
}]